import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

const VARIANTS = {
  primary:
    "bg-brand text-white hover:bg-brand-hover border border-transparent",
  secondary:
    "bg-transparent text-charcoal border border-charcoal/20 hover:border-charcoal/50 hover:bg-surface",
  light:
    "bg-white text-charcoal border border-white hover:bg-white/90",
  outlineLight:
    "bg-transparent text-white border border-white/30 hover:border-white/80 hover:bg-white/5",
};

// One consistent button system across the whole site.
export function CTAButton({
  to,
  href,
  variant = "primary",
  children,
  icon: Icon = ArrowRight,
  showIcon = true,
  className,
  testid,
  onClick,
  ...rest
}) {
  const base = cn(
    "group inline-flex items-center justify-center gap-2.5 rounded-sm px-7 py-4 text-sm font-medium tracking-wide transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2",
    VARIANTS[variant],
    className
  );

  const inner = (
    <>
      <span>{children}</span>
      {showIcon && Icon && (
        <Icon
          className="h-4 w-4 shrink-0 transition-transform duration-300 group-hover:translate-x-1"
          strokeWidth={2}
        />
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} data-testid={testid} className={base} onClick={onClick} {...rest}>
        {inner}
      </Link>
    );
  }
  return (
    <a href={href} data-testid={testid} className={base} onClick={onClick} {...rest}>
      {inner}
    </a>
  );
}
